import React from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { detectMobileDevice, subMinutes } from "utils";
import Session from "utils/Session";
import { createGuestSession, restoreSession, signOut } from "services/auth";
import { useNavigate } from "react-router-dom";

function SessionHelper({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);

  const isTokenExpiring = () => {
    console.log("DEBUG::isTokenExpiring");
    return subMinutes(new Date(Session.accessTokenExpiry), 5) <= new Date();
  };
  const isRefreshTokenExpiring = () => {
    return (
      subMinutes(new Date(Session.refreshTokenExpiry), 5).getTime() <=
      new Date().getTime()
    );
  };

  const goToError = async () => {
    console.log("DEBUG::gotToError");
    await signOut();
  };

  async function onLoad() {
    setLoading(true);

    const pathname = window.location.pathname;
    const mobileFriendlyRoute =
      pathname === '/' || pathname.startsWith('/practice');

    if (detectMobileDevice() && !mobileFriendlyRoute) {
      navigate("/unsupported-device");
      return;
    }

    try {
      // if the refresh token is expiring then sign out and redirect to sign in
      const languifyRefreshTokenExpiry = localStorage.getItem(
        "languifyRefreshTokenExpiry"
      );

      if (languifyRefreshTokenExpiry) {
        const refreshTokenExpiryTime = new Date(
          parseInt(languifyRefreshTokenExpiry, 10)
        ).getTime();
        Session.refreshTokenExpiry =
          refreshTokenExpiryTime <= new Date().getTime()
            ? new Date().getTime()
            : refreshTokenExpiryTime;
      }

      if (isRefreshTokenExpiring()) {
        console.log("DEBUG::RefreshTokenExpired");
        await goToError();
        console.log("DEBUG::Creating guest session");
        await createGuestSession();
        return;
      }

      console.log("DEBUG::isLoggedIn: ", Session.isLoggedIn());
      if (isTokenExpiring()) {
        console.log("DEBUG::AccessTokenExpired");
        Session.accessToken = "";
      }

      await restoreSession();

      setLoading(false);
    } catch (e) {
      console.log("DEBUG::onLoad error: ", e);
    } finally {
      setLoading(false);
    }
  }

  async function setupRefresh() {
    try {
      if (isRefreshTokenExpiring()) {
        console.log("DEBUG::RefreshTokenExpired-2");
        await goToError();
      }

      if (Session.isLoggedIn()) {
        if (isTokenExpiring()) Session.accessToken = "";

        await restoreSession();
      }
    } catch (e) {
      console.error("setupTokenRefresh -> error refreshing token", e);
      await goToError();
    }
  }

  React.useEffect(() => {
    onLoad().catch(() => setLoading(false));

    const timerId = setInterval(setupRefresh, 3600000);

    return () => clearInterval(timerId);
  }, []);

  return loading ? (
    <Box
      width={"100vw"}
      height={"100vh"}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress variant="indeterminate" />
    </Box>
  ) : (
    <>{children}</>
  );
}

export default SessionHelper;
